export default "__VITE_ASSET__CamjXf$U__"